/**
 * Checks if an OIDC error should suppress user notification.
 * "No matching state found in storage" indicates the OIDC flow was interrupted
 * (e.g., cleared storage, expired state, or navigation timing issues).
 * While the auth flow still needs to be reset, this error is somewhat expected
 * during certain navigation scenarios and would be confusing to surface to users.
 *
 * @param error - The error object to check
 * @returns true if the error should not trigger a user-facing notification
 */
export const shouldSuppressOidcErrorNotification = (
  error: Error | null | undefined
): boolean => {
  return /No matching state found in storage/i.test(error?.message ?? '');
};
